module.exports = __webpack_public_path__ + "r-v3/img/band.8b5da305.png";